import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeSwitcherProps {
  className?: string
  onToggle?: () => void
}

const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ className = '', onToggle }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={() => {
        onToggle?.()
        toggleTheme()
      }}
      className={`hdr-dd-btn ${className}`}
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      style={{
        background: 'transparent',
        border: 'none',
        color: 'inherit',
        cursor: 'pointer',
        padding: '0.5rem',
        borderRadius: 'var(--radius-sm)',
        transition: 'all var(--transition-base)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontSize: '0.875rem',
        fontWeight: '500'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--accent-dim)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      {theme === 'light' ? (
        <>
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
            <circle cx="8" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.2" />
            <path d="M8 1V3M8 13V15M15 8H13M3 8H1M12.5 3.5L11 5M5 11L3.5 12.5M12.5 12.5L11 11M5 5L3.5 3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
          Light
        </>
      ) : (
        <>
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
            <path d="M8 1C4.5 1 1.5 4 1.5 8S4.5 15 8 15C11.5 15 14.5 12 14.5 8C14.5 7 14 6 13 5.5C12 5 11 5.5 10 5.5C8.5 5.5 7.5 4.5 7.5 3C7.5 2 8 1 8 1Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Dark
        </>
      )}
    </button>
  );
};

export default ThemeSwitcher;
